import LinkTabs from './link-tabs'

export default LinkTabs
